import { render } from "./GreenDetailContent.vue?vue&type=template&id=050ba34a&scoped=true"
import script from "./GreenDetailContent.vue?vue&type=script&lang=js"
export * from "./GreenDetailContent.vue?vue&type=script&lang=js"

import "./GreenDetailContent.vue?vue&type=style&index=0&id=050ba34a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050ba34a"]])

export default __exports__